/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { MdAnalytics, MdMapsHomeWork } from 'react-icons/md';
import { FaMoneyCheckDollar, FaRankingStar } from 'react-icons/fa6';
import FunctionItem from 'components/common/FunctionItem';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constants/router';
import useDirection from 'hooks/useDirection';
import { createPortal } from 'react-dom';
import { IconType } from 'react-icons';
import AvailableRoomCard from 'components/card/AvailableRoomCard';
import { getListAvailableRoom } from 'services/property.service';
import { delayNavigate, isSuccessCode } from 'utils/common';
import { RoomType } from 'types/property.type';
import LoadMoreList from 'components/common/LoadMoreList';
import BottomSpace from 'components/common/BottomSpace';
import usePagination from 'hooks/usePagination';
import { countUnreadNotify } from 'services/notify.service';
import { dispatch } from 'store/Store';
import { setCountInfo } from 'store/common';

type FunctionItemType = {
  title: string;
  icon: IconType;
  numberOfNotify: number;
  path: string;
  disabled?: boolean;
};

const FUNCTIONS = [
  {
    title: 'title.partner',
    icon: MdMapsHomeWork,
    numberOfNotify: 0,
    path: ROUTES.PARTNER,
  },
  {
    title: '...',
    icon: FaRankingStar,
    numberOfNotify: 0,
    path: ROUTES.RANKING,
    disabled: true,
  },
  {
    title: '...',
    icon: FaMoneyCheckDollar,
    numberOfNotify: 0,
    path: ROUTES.COMMISSION,
    disabled: true,
  },
  {
    title: '...',
    icon: MdAnalytics,
    numberOfNotify: 0,
    path: ROUTES.STATISTIC,
    disabled: true,
  },
];

export default function HomeContainer() {
  const { t } = useTranslation();
  const { goTo } = useDirection();
  const { currentPage, limit, onNext } = usePagination();
  const [functions, setFunctions] = useState<FunctionItemType[]>([]);
  const [availableRooms, setAvailableRooms] = useState<RoomType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstLoading, setIsFirstLoading] = useState(true);
  const total = useRef(0);

  const getListRoom = async () => {
    const response = await getListAvailableRoom({
      page: currentPage,
      limit,
    });
    const { data, code } = response?.data;
    if (isSuccessCode(code)) {
      setAvailableRooms(data?.data);
      total.current = Number(data?.total);
    }
    delayNavigate(() => setIsFirstLoading(false));
  };

  const handleLoadMore = async (page: number) => {
    setIsLoading(true);
    const response = await getListAvailableRoom({
      page: page,
      limit,
    });
    const { data, code } = response?.data;
    if (isSuccessCode(code)) {
      const newList = availableRooms.concat(data?.data);
      setAvailableRooms(newList);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (currentPage > 1) {
      handleLoadMore(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    setFunctions(FUNCTIONS);
    getListRoom();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const [notify] = await Promise.all([countUnreadNotify()]);
      dispatch(
        setCountInfo({
          notify: notify?.data?.data?.total,
          debitInvoice: 0,
        }),
      );
    };
    getData();
  }, []);

  return (
    <div className={styles.wrapper}>
      {createPortal(
        <div className="function-wrapper">
          {functions?.map((func, idx) => {
            return (
              <FunctionItem
                key={idx}
                title={t(func.title)}
                Icon={func.icon}
                numberOfNotify={func.numberOfNotify}
                disabled={func.disabled}
                onClick={
                  func.path
                    ? goTo(func.path)
                    : () => {
                        return;
                      }
                }
              />
            );
          })}
        </div>,
        document.getElementById('header-content') || document.body,
      )}
      <div className={styles.contract}>
        <div>
          <p className={`font-bold font-xl color-black ${styles.title}`}>
            {t('title.up-coming-room')}
          </p>
        </div>
        <div className={styles.listItem}>
          <LoadMoreList
            isFirstLoading={isFirstLoading}
            isLoading={isLoading}
            isEnded={availableRooms.length >= total.current}
            loadingElement={
              <>
                <AvailableRoomCard isSkeleton />
                <AvailableRoomCard isSkeleton />
                <AvailableRoomCard isSkeleton />
              </>
            }
            onLoadMore={onNext}
          >
            {availableRooms.map((room) => {
              return (
                <AvailableRoomCard
                  key={room.id}
                  price={Number(room?.price)}
                  buildingName={room?.building?.name}
                  branchName={room?.branch?.name}
                  roomName={room?.name}
                  availableDate={room?.latestBooking?.endDate}
                  address={[
                    room?.building?.address,
                    room?.building?.district?.name,
                    room?.building?.province?.name,
                  ].join(', ')}
                  branchImgUrl={room?.branch?.branchDetail?.appLogo}
                  onClick={goTo(
                    ROUTES.ROOM_DETAIL.replace(':roomId', String(room?.id))
                      .replace(':buildingId', String(room?.buildingId))
                      .replace(':branchId', String(room?.branchId)),
                  )}
                />
              );
            })}
          </LoadMoreList>
        </div>
      </div>
      <BottomSpace />
    </div>
  );
}
